<template>
    <b-overlay :show="calculating" opacity="0.2">
        <div class="row">
            <div class="col-lg-6 mb-1">
                <label class="form-label">Personel</label>
                <v-validator :errors="errors" parameter="EmployeeId" :watch="employee">
                    <v-select-list v-model="employee" :options="employees" label="Combine" v-on:input="getOrders" v-on:search="searchEmployees" placeholder="Personel" :loading="employeeLoading"></v-select-list>
                </v-validator>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">Sıra Numarası</label>
                <v-validator :errors="errors" parameter="OrderNumber" :watch="value.OrderNumber">
                    <input class="form-control" disabled v-model="value.OrderNumber" type="number" placeholder="Sıra Numarası"/>
                </v-validator>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">Tebliğ Türü</label>
                <v-validator :errors="errors" parameter="CommuniqueType" :watch="value.CommuniqueType">
                    <select class="form-control" v-model="value.CommuniqueType">
                        <option :value="null" v-if="value.CommuniqueType == null">Seçiniz</option>
                        <option v-for="ct in communiqueTypes" :key="ct" :value="ct">{{ct}}</option>
                    </select>
                </v-validator>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">Tebliğ Tarihi</label>
                <v-validator :errors="errors" parameter="CommuniquedDate" :watch="value.CommuniquedDate">
                    <v-date-picker v-model="value.CommuniquedDate" for-back type="datetime" v-on:input="getOrders" placeholder="Tebliğ Tarihi"></v-date-picker>
                </v-validator>
                <b-form-checkbox class="mt-75" v-model="value.ShowDateOrder">Önceliklendirme Tarihini Değiştir</b-form-checkbox>
            </div>
            <div class="col-12 mb-1" v-if="value.ShowDateOrder">
                <div class="bg-light rounded p-75">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <label class="form-label">Önceliklendirme Tarihi</label>
                            <v-validator :errors="errors" parameter="DateForOrder" :watch="value.DateForOrder"> 
                                <v-date-picker v-model="value.DateForOrder" for-back type="datetime" v-on:input="getOrders" placeholder="Sıralama Tarihi"></v-date-picker>
                            </v-validator>
                        </div>
                        <div class="col-12">
                            <label class="form-label">Önceliklendirme Açıklaması</label>
                            <v-validator :errors="errors" parameter="OrderDescription" :watch="value.OrderDescription"> 
                                <textarea class="form-control resize-none" rows="2" v-model="value.OrderDescription" placeholder="Sıralama Açıklaması"></textarea>
                            </v-validator>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">İcra Ofisi</label>
                <v-validator :errors="errors" parameter="LevyOfficeId" :watch="levyOffice">
                    <v-select-list v-model="levyOffice" :options="levyOffices" :disabled="value.PayeeGovernment" label="Combine" placeholder="İcra Ofisi"></v-select-list>
                </v-validator>
                <b-form-checkbox class="mt-75" v-model="value.PayeeGovernment" v-on:change="getOrders">Devlet Dairesi</b-form-checkbox>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">İcra Ofisi Banka Hesap Numarası</label>
                <v-validator :errors="errors" parameter="LevyOfficeBankAccountNumber" :watch="value.LevyOfficeBankAccountNumber">
                    <input class="form-control" v-model="value.LevyOfficeBankAccountNumber" placeholder="İcra Ofisi Banka Hesap Numarası"/>
                </v-validator>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">Dosya Numarası</label>
                <v-validator :errors="errors" parameter="FileNumber" :watch="value.FileNumber"> 
                    <input class="form-control" v-model="value.FileNumber" placeholder="Dosya Numarası"/>
                </v-validator>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">Alacaklı</label>
                <v-validator :errors="errors" parameter="Payee" :watch="value.Payee"> 
                    <input class="form-control mb-50" v-model="value.Payee" placeholder="Alacaklı"/>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <b-form-checkbox v-model="value.FixedDeduction">Sabit Kesinti</b-form-checkbox>
            </div>
            <div class="col-lg-6 mb-1">
                <label class="form-label">{{value.FixedDeduction ? 'Aylık Ödeme Tutarı (TL)' : 'Toplam Borç (TL)'}}</label>
                <v-validator :errors="errors" parameter="TotalDebtAmount" :watch="value.TotalDebtAmount"> 
                    <input class="form-control" v-model="value.TotalDebtAmount" type="number" :placeholder="value.FixedDeduction ? 'Aylık Ödeme Tutarı (TL)' : 'Toplam Borç (TL)'"/>
                </v-validator>
            </div>
            <!-- <div class="col-lg-6 mb-1" v-if="!value.FixedDeduction">
                <label class="form-label">Ödenen Miktar</label>
                <v-validator :errors="errors" parameter="PaidAmount" :watch="value.PaidAmount"> 
                    <input class="form-control" v-model="value.PaidAmount" type="number" placeholder="Ödenen Miktar"/>
                </v-validator>
            </div> -->
            <!-- <div :class="[value.FixedDeduction ? 'col-lg-6' : 'col-12','mb-1']">
                <label class="form-label">Ödeme Başlangıç Tarihi</label>
                <v-validator :errors="errors" parameter="FirstInstallmentDate" :watch="value.FirstInstallmentDate"> 
                    <v-date-picker v-model="value.FirstInstallmentDate" for-back type="datetime" placeholder="Ödeme Başlangıç Tarihi"></v-date-picker>
                </v-validator>
            </div> -->
            <div class="col-12 mb-1">
                <div class="bg-light rounded p-75">
                    <div class="row">
                        <div class="col-12">
                            <label class="form-label">İcra Durumu</label>
                            <v-validator :errors="errors" parameter="Accepted" :watch="value.Accepted">
                                <select class="form-control" v-model="value.Accepted" v-on:change="getOrders">
                                    <option :value="null">Bilinmiyor</option>
                                    <option :value="true">Kabul Edildi</option>
                                    <option :value="false">Reddedildi</option>
                                </select>
                            </v-validator>
                        </div>
                        <div class="col-12 mt-1" v-if="value.Accepted != null">
                            <label class="form-label">Yanıt Tarihi</label>
                            <v-validator :errors="errors" parameter="AnswerDate" :watch="value.AnswerDate"> 
                                <v-date-picker v-model="value.AnswerDate" for-back type="datetime" v-on:input="getOrders" placeholder="Yanıt Tarihi"></v-date-picker>
                            </v-validator>
                        </div>
                        <div class="col-12 mt-1" v-if="value.Accepted == false">
                            <label class="form-label">Ret Açıklaması</label>
                            <v-validator :errors="errors" parameter="RejectDescription" :watch="value.RejectDescription"> 
                                <textarea class="form-control resize-none" rows="2" v-model="value.RejectDescription" placeholder="Ret Açıklaması"></textarea>
                            </v-validator>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="bg-light rounded p-75" v-if="value.EmployeeId && this.value.PayeeGovernment != null && this.value.CommuniquedDate && (this.value.Orders || []).length != 0">
                    <div class="d-flex align-items-center justify-content-between mb-1">
                        <h4 class="p-50 font-weight-bolder mb-0">Diğer İcralar</h4>
                    </div>
                    <ul class="list-group">
                        <li class="list-group-item p-25" v-for="(d,index) in value.Orders" :key="(d || 0) + index">
                            <div class="current-box d-flex" :class="[editing ? 'secondary' : 'success',getCurrent(d) ? 'active' : null]">
                                <table class="table table-sm table-bordered mb-0">
                                    <tbody>
                                        <tr v-if="getCurrent(d)">
                                            <td colspan="100" class="font-weight-bolder" :class="editing ? 'bg-light-secondary' : 'bg-light-success'">
                                                <div class="d-flex align-items-center">
                                                    {{ editing ? 'Düzenlenen' : 'Yeni' }} 
                                                    <b-badge class="ml-75" variant="warning" v-if="d.Accepted == null">
                                                        Kabul edilmemiştir. Kabul edildiği durum için sıralama gösterilmektedir.
                                                    </b-badge>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="w-25">
                                                <div class="font-weight-bolder">Sıra</div>
                                                {{ d.OrderNumber }}
                                            </td>
                                            <td class="w-25">
                                                <div class="text-nowrap font-weight-bolder">Dosya Numarası</div>
                                                <template v-if="getCurrent(d)">
                                                    {{ value.FileNumber || '-' }}
                                                </template>
                                                <template v-else>
                                                    {{ d.DocumentNumber || '-' }}
                                                </template>
                                            </td>
                                            <td class="w-25">
                                                <div class="text-nowrap font-weight-bolder">Yanıt Tarihi</div>
                                                {{d.DateStr || '-'}}
                                            </td>
                                            <td class="w-25">
                                                <div class="text-nowrap font-weight-bolder">Devlet Dairesi</div>
                                                <span v-if="d.Official" class="material-icons-outlined d-block text-success">check_circle</span>
                                                <span v-else class="material-icons-outlined d-block text-danger">cancel</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="alert alert-info mb-0" v-else>
                    <div class="alert-body">
                        <b>Personel</b>, <b>Devlet Dairesi</b> ve <b>Tebliğ Tarihi</b> seçildiğinde veya değiştirildiğinde sıra numarası otomatik olarak hesaplanacaktır. Öncelikli sıralama için <b>Önceliklendirme Tarihini</b> değiştirebilirsiniz.
                    </div>
                </div>
            </div>
            <div class="col-12 mt-1">
                <div class="row">
                    <div class="col-12 mb-1" v-if="editing && (value.FileNumber != value.BaseFileNumber)">
                        <label class="form-label">Dosya Numarası Değişikliği Açıklaması (<span class="text-muted">{{ value.BaseFileNumber }}</span> -> {{ value.FileNumber }})</label>
                        <textarea class="form-control resize-none" v-model="value.FileNumberChangeDescription"  placeholder="Dosya Numarası Değişikliği Açıklaması" rows="3"></textarea>
                    </div>
                    <div class="col-12" v-if="editing && (value.TotalDebtAmount != value.BaseTotalDebtAmount)">
                        <label class="form-label">{{value.FixedDeduction ? 'Aylık Ödeme Tutarı' : 'Toplam Borç'}} Değişikliği Açıklaması (<span class="text-muted">{{ convertMoney(value.BaseTotalDebtAmount) }}₺</span> -> {{ convertMoney(value.TotalDebtAmount) }}₺)</label>
                        <textarea class="form-control resize-none" v-model="value.AmountChangeDescription" :placeholder="`${value.FixedDeduction ? 'Aylık Ödeme Tutarı' : 'Toplam Borç'} Değişikliği Açıklaması`"  rows="3"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import CompanyApi from '@/api/company'
import { BFormCheckbox,BFormSpinbutton, BOverlay, BBadge } from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'
import Additional from '@/utilities/additional'

export default {
    components:{
        BFormCheckbox,
        BFormSpinbutton,
        BOverlay,
        BBadge,
    },
    props:{
        value:Object,
        errors:Object,
        editing:Boolean
    },
    data() {
        return {
            employeeLoading:false,
            employees:[],
            levyOffices:[],
            sgkBranches:[],
            communiqueTypes:["Posta","UETS"],
            calculating:false,
        }
    },
    watch:{
        // "value.PayeeGovernment"(){
        //     this.value.LevyOfficeId = null
        // },
    },
    mounted(){
        this.getSGKBranches()
        this.getLevyOffices()
        if(this.value.Employee){
            this.searchEmployees(this.value.Employee.FullName)
        }
        this.getOrders()
    },
    methods:{
        searchEmployees(search){
            if(search){
                this.employeeLoading = true
                EmployeeOperationsApi.Employee.Search(String(search).toLowerCase())
                .then(res=>{
                    this.employees = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.IdentityNumber,d.FullName].join(' - ')
                    }))
                    this.employeeLoading = false
                }).catch(err=>{ 
                    this.employeeLoading = false 
                })
            }
        },
        getCurrent(d){
            if(this.editing){
                return d.Id == this.value.Id
            }else{
                return d.Id == null && d.DocumentNumber == null
            }
        },
        getSGKBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sgkBranches = res.data.Data
            })
        },
        getLevyOffices(){
            SystemDataApi.LevyOfficeList().then(res=>{
                this.levyOffices = res.data.Data?.map(l=>({
                    ...l,
                    Combine:[l.Name,l.LevyOfficeAccountTypeValue].join(' - ')
                }))
            })
        },
        getOrders(){
            if(this.value.EmployeeId && this.value.PayeeGovernment != null && this.value.CommuniquedDate){
                this.calculating = true
                EmployeeOperationsApi.Levy.CalculateOrder({
                    Id:this.value.Id,
                    EmployeeId:this.value.EmployeeId,
                    FirstPayDay:this.value.CommuniquedDate,
                    Official:this.value.PayeeGovernment,
                    OrderNumber:this.editing ? this.value.OrderNumber : null,
                    DateForOrder:this.value.DateForOrder,
                    Accepted:this.value.Accepted,
                    CommuniquedDate: this.value.CommuniquedDate
                }).then(res=>{
                    this.calculating = false
                    if(res.data.Success){
                        this.value.Orders = res.data.Data
                        this.value.OrderNumber = res.data.Data?.find(d=>d.Id == null && d.DocumentNumber == null)?.OrderNumber || this.value.OrderNumber
                    }
                }).catch(err=>{
                    this.calculating = false
                })
            }
        },
        updateOrders(){
            this.value.Orders?.forEach((o,i)=>{
                o.OrderNumber = (i+1)
            })
            this.value.OrderNumber = this.value.Orders.find(o=>o.Id == this.value?.Id)?.OrderNumber || this.value.OrderNumber
        },
        convertMoney(n){
            return Additional.ConvertMoney(n)
        }
    },
    computed:{
        employee:{
            get:function(){
                return this.employees.find(s=>s.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
        sgkBranch:{
            get:function(){
                return this.sgkBranches.find(b=>b.Id==this.value.SGKBranchId)
            },
            set:function(value){
                this.value.SGKBranchId = value?.Id || null
            }
        },
        levyOffice:{
            get:function(){
                return this.levyOffices.find(s=>s.Id==this.value.LevyOfficeId)
            },
            set:function(value){
                this.value.LevyOfficeId = value?.Id || null
                this.value.LevyOfficeBankAccountNumber = value?.IBAN || null
            }
        },
    }
}
</script>

<style>
.lock{
    font-size:16px;
}
.current-box{
    border-width: 2px;
    border-style:solid;
    border-color: transparent;
}

.current-box.active.success{
    border-color: var(--success);
}
.current-box.active.secondary{
    border-color: var(--secondary);
}
.status{
    width: 1.5rem;
    color: white;
}

.current-box.active.success .status{
    background-color: var(--success);
}
.current-box.active.secondary .status{
    background-color: var(--secondary);
}

</style>